import request from './request';


// 索样 留言

export function MemberConsultation_add(data) {
    return request({
        url: `SeekSample/publishSeek`,
        method: 'post',
        data
    })
}
// 发布索样获取基础数据
export function getSeekIndex(params) {
    return request({
        url: `seekSample/getSeekIndex`,
        method: 'get',
        params
    })
}


//产品列表
export function productLists(params) {
    return request({
        url: 'product/lists',
        method: 'get',
        params
    })
}
//产品分类
export function categoryLists(params) {
    return request({
        url: 'product/categoryLists',
        method: 'get',
        params
    })
}
//产品详情
export function productDetail(params) {
    return request({
        url: 'product/detail',
        method: 'get',
        params
    })
}



